import {
  ArrowDropDownOutlined as MuiArrowDropDownOutlinedIcon,
  Cancel as MuiCancelIcon,
  CheckCircle as MuiCheckCircleIcon,
} from "@mui/icons-material";
import {
  Button as MuiButton,
  IconButton as MuiIconButton,
  Menu as MuiMenu,
  MenuItem as MuiMenuItem,
  TextField as MuiTextField,
} from "@mui/material";
import { useAlerts } from "common";
import { getUser, useUsers } from "common/services/UsersService/UsersProvider";
import React from "react";
import { useNavigate } from "react-router";
import { HeaderContainer } from "./Header.styles";
import { ImpersonateContainer } from "./Impersonate.styles";
import { Logo } from "./Logo";

export const Header = ({ logoTitle, logoSubtitle, userDisplayName }) => {
  const { loggedInUser } = useUsers();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const [openImpersonationSection, setOpenImpersonationSection] =
    React.useState(false);

  const handleViewAsMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleViewAsMenuClose = () => {
    setAnchorEl(null);
    setOpenImpersonationSection(true);
  };

  const handleViewAsMenuClickAway = () => {
    setAnchorEl(null);
    setOpenImpersonationSection(false);
  };

  return (
    <HeaderContainer>
      {openImpersonationSection && (
        <ImpersonationSection
          setOpenImpersonationSection={setOpenImpersonationSection}
        />
      )}
      <header id="header" className="header-local" role="banner">
        <div className="container">
          <span className="skip-to-links">
            <a href="#mainContent" className="sr-only sr-only-focusable">
              Skip to Content
            </a>
            <a href="#navigationLocal" className="sr-only sr-only-focusable">
              Skip to Local Navigation
            </a>
          </span>
          <Logo logoTitle={logoTitle} logoSubtitle={logoSubtitle} />
          <div id="headerContent" />
        </div>
        <div className="display-name">
          {loggedInUser.canImpersonate && !openImpersonationSection ? (
            <>
              <MuiButton
                className="display-name-button"
                endIcon={<MuiArrowDropDownOutlinedIcon />}
                onClick={handleViewAsMenuOpen}
                aria-haspopup="true"
              >
                {userDisplayName}
              </MuiButton>
              <MuiMenu
                anchorEl={anchorEl}
                open={open}
                onClose={handleViewAsMenuClickAway}
                keepMounted
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <MuiMenuItem
                  onClick={handleViewAsMenuClose}
                  className="impersonation-item"
                >
                  View As ...
                </MuiMenuItem>
              </MuiMenu>
            </>
          ) : (
            <>{userDisplayName}</>
          )}
        </div>
      </header>
    </HeaderContainer>
  );
};

const ImpersonationSection = (props) => {
  const navigate = useNavigate();
  const { setOpenImpersonationSection } = props;

  const { setAlert, clearAlert } = useAlerts();
  const {
    currentUser,
    setCurrentUser,
    setAccessDenied,
    initImpersonateUser,
    clearImpersonateUsername,
  } = useUsers();

  const [inputUsername, setInputUsername] = React.useState("");

  const handleUsernameChange = (username) => {
    setInputUsername(username);
  };

  const startImpersonate = () => {
    // TODO: Uncomment this initImpersonateUser line and delete the following one once the switch to Entra ID is complete
    // initImpersonateUser(
    //   // If the inputted Username does not include a domain, append @stanford.edu for the domain
    //   inputUsername.includes("@")
    //     ? inputUsername
    //     : `${inputUsername}@stanford.edu`,
    // );
    initImpersonateUser(inputUsername);
    setAccessDenied(true);
    getUser(setCurrentUser, true, false, setAlert, clearAlert, setAccessDenied);
    navigate("/");
  };

  const stopImpersonation = () => {
    setInputUsername("");
    clearImpersonateUsername();
    getUser(
      setCurrentUser,
      false,
      false,
      setAlert,
      clearAlert,
      setAccessDenied,
    );
    setOpenImpersonationSection(false);
    navigate("/");
  };

  const cancelImpersonation = () => {
    setInputUsername("");
    setOpenImpersonationSection(false);
    if (currentUser.permissions === null) {
      clearImpersonateUsername();
      getUser(
        setCurrentUser,
        false,
        false,
        setAlert,
        clearAlert,
        setAccessDenied,
      );
      navigate("/");
    }
  };

  const impersonateWrapper = `impersonateContainer ${
    currentUser.isImpersonated ? "impersonating" : ""
  }`;

  return (
    <ImpersonateContainer>
      <div className={impersonateWrapper}>
        {currentUser.isImpersonated ? (
          <div className="impersonateShow">
            <div className="gridContainerStyle">
              <label className="viewAsLabelStyle">
                Viewing as {currentUser.displayName}
              </label>
              <MuiIconButton
                onClick={() => {
                  stopImpersonation();
                }}
                id="impersonationBannerCancelImpersonation"
              >
                <MuiCancelIcon />
              </MuiIconButton>
            </div>
          </div>
        ) : (
          <div className="impersonateEdit">
            <div className="gridContainerStyle">
              <span className="viewAsLabelStyle">View As:</span>
              <MuiTextField
                name="username"
                label="Username"
                className="impersonateInputName"
                size="small"
                variant="outlined"
                margin="dense"
                fullWidth
                value={inputUsername}
                onChange={(e) => handleUsernameChange(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && inputUsername) {
                    startImpersonate();
                  }
                }}
              />
              <MuiIconButton
                disabled={!inputUsername}
                onClick={startImpersonate}
              >
                <MuiCheckCircleIcon />
              </MuiIconButton>
              <MuiIconButton onClick={cancelImpersonation}>
                <MuiCancelIcon />
              </MuiIconButton>
            </div>
          </div>
        )}
      </div>
    </ImpersonateContainer>
  );
};
